<div class="fondo puffIn">
    <div style="text-align: -webkit-center;">
        <div id="buscador" class="buscador-container " [style.background-color]="data.background_color">
            <h1 class="titulo-buscador quicksand-medium" [style.color]="data.color_title">{{data.title}}</h1>
            <h5 class="subtitulo-buscador quicksand-medium" [style.color]="data.color_subtitle">{{data.subtitle}}
            </h5>



            <form [formGroup]="buscador" class="form-group" id="busqueda" style='justify-content: space-between;'>

                <div style="display: flex;
                flex-wrap: wrap; width: 100%; justify-content: space-between;">
                    <div class="input-container">
                        <input #filtroInput  type="text" formControlName='filtro'
                            (keyup)="(filtroInput.value.length >= 3 || filtroInput.value.length==0)? filtrar($event) : null"
                            class="form-control-c nunito-medium " placeholder="Palabra clave">
                        <img class="buscar" src="../../../../../assets/img/buscar-azul.png" alt="">
                        <!--  <div class="buscar-icon"></div>          -->
                    </div>

                    <div class="input-container">

                        <app-custom-select [colorArrow]="'azul'" [options]="areas" placeholder="Elegí el área"
                            placeholderAll="Todas las áreas" (selectionChange)="updateFilter('area', $event)"
                            [color]="'blue'" [id]="'select-area'">
                        </app-custom-select>
                    </div>

                    <div *ngIf="mostrarSede" class="input-container">

                        <app-custom-select [colorArrow]="'azul'" [options]="regiones" placeholder="Elegí la sede"
                            placeholderAll="Todas las sedes" (selectionChange)="updateFilter('sede', $event)"
                            [color]="'blue'" [id]="'select-sede'">
                        </app-custom-select>
                    </div>
                    <div class="input-container" style=" margin-right: 0px !important;">

                        <app-custom-select [colorArrow]="'azul'" [options]="modalidades" placeholder="Modalidad"
                            placeholderAll="Todas las modalidades" (selectionChange)="updateFilter('modalidad', $event)"
                            [color]="'blue'" [id]="'select-modalidad'">
                        </app-custom-select>
                    </div>

                </div>

            </form>
        </div>
    </div>
    <div class="resultados  " id="resultados" style="    text-align: -webkit-center;">
        <ul *ngIf='!spinner' style="padding-inline-start: 0px !important">


            <div class="container-resultados-cursos">
                <ng-container *ngFor='let carrera of resultados; let i = index'>
                    <app-card-overlay2 class="spaceInUp zoomIn" [carrera]="carrera" [borde]="true"
                        [busqueda]="pages.length > 1"></app-card-overlay2>

                </ng-container>
            </div>


        </ul>
        <div class="d-flex justify-content-center spinner" *ngIf='spinner'>
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>


        <div class="paginacion" *ngIf='resultados.length > 0 && pages.length > 1 && !spinner'>
            <ng-container *ngFor="let page of visiblePages2">
                <div class="number" [ngClass]='(numberActive == page) ? "active" : ""' *ngIf="page !== '...'"
                    (click)='cambiarPagina(page)'>
                    {{ page }}
                </div>
                <div class="dots" *ngIf="page === '...'">
                    {{ page }}
                </div>
            </ng-container>
        </div>
        <div *ngIf=' resultados.length == 0 && !spinner && !destacadas' class='p-3 text-center no-result'>
            <app-areas-recomendadas [infoAreaRecomendada]="infoAreaRecomendada"></app-areas-recomendadas>
        </div>


        <!--<div *ngIf=' resultados.length == 0 && !spinner && !destacadas' class='p-3 text-center no-result'>
            <div class="alert alert-primary text-center" role="alert">
                No hay resultados
            </div>
        </div>-->
    </div>
</div>